<template>
  <div>
    <div
      v-if="userInfo.token && (!userInfo.corpList || !userInfo.corpList.length)"
      class="auth-box"
    >
      <Icon
        type="ios-alert"
        color="#FB6441"
        size="20"
        style="margin-right: 5px; vertical-align: middle;"
      />
      <span class="auth-tip">当前的登录账户主体信息未做认证，认证后才能开通使用产品服务</span>
      <button
        class="vertify-btn"
        @click="authModal.on.show"
      >
        前往认证
      </button>
    </div>
    <div
      class="header-box"
      :style="headerStyle"
    >
      <div class="header">
        <div class="wrap1200">
          <div class="header-col header-left">
            <img
              class="logo-img"
              src="@/assets/images/logo.png"
              alt
              @click="goHome"
            >
          </div>
          <div class="header-col header-menu1">
            <div class="menu">
              <div class="menu-list">
                <div
                  class="menu-item"
                  @mouseleave="hideProduct"
                  @mouseenter="showProduct"
                >
                  <span>产品</span>
                  <Icon
                    type="ios-arrow-down"
                    style="transition: all 0.5s;margin-left: 10px"
                    :class="{'product-show': product.show}"
                  />
                </div>
                <div
                  v-for="(item,index) in menuList"
                  :key="index"
                  class="menu-item"
                  @click="changeTab(item)"
                >
                  {{ item.privilegeName }}
                </div>
              </div>
            </div>
          </div>
          <div class="header-col header-right">
            <div
              v-if="userInfo.userPhone"
              class="is-login"
            >
              <Button
                v-show="$route.name !== 'mainIndex'"
                type="primary"
                to="/"
                style="background-color: #4772fc;
                  border-color: #4772fc;
                  margin-right: 40px;
                  font-size: 14px;
                  border-radius: 2px"
              >
                进入工作台
              </Button>
              <Dropdown class="dropdown-box">
                <div style="display: flex; align-items: center;">
                  <img
                    class="user-icon"
                    src="@/assets/images/user.png"
                  >
                  <div>
                    <div style="padding: 0;">
                      {{ userInfo.userPhone|passFormat }}
                    </div>
                    <div style="padding: 0; font-size: 12px; color: #999;">
                      {{ userInfo.corpName | filterCorpName }}
                    </div>
                  </div>
                </div>
                <DropdownMenu slot="list">
                  <Dropdown
                    placement="right-start"
                  >
                    <DropdownItem>
                      切换主体
                      <Icon type="ios-arrow-forward"></Icon>
                    </DropdownItem>
                    <DropdownMenu slot="list">
                      <DropdownItem
                        v-for="(item,index) in userInfo.corpList"
                        :key="index"
                      >
                        <div
                          class="corpList-item"
                          @click="corpList.on.click(index)"
                        >
                          <span>{{ item.value }}</span>
                        </div>
                      </DropdownItem>
                      <DropdownItem>
                        <span
                          class="add-corp"
                          @click="goMyCorp"
                        >+新增主体</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <DropdownItem
                    v-for="(item,index) in dropdownMenu.list"
                    :key="index"
                  >
                    <div
                      @click="item.on.click"
                    >
                      <Icon
                        :type="item.icon"
                        size="16"
                      />
                      <span class="drop-item-name">{{ item.title }}</span>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>

            <div
              v-else
              class="userinfo"
            >
              <!-- <Avatar icon="ios-person"></Avatar> -->
              <button
                class="btn btn1"
                @click="goLogin"
              >
                登录
              </button>
              <button
                class="btn btn2"
                @click="register"
              >
                注册
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="product"
        :class="{show: product.show}"
        @mouseenter="showProduct"
        @mouseleave="hideProduct"
      >
        <div class="wrap1200">
          <div class="product-title">
            产品
          </div>
          <ul class="product-list">
            <li
              v-for="(item,index) in product.list"
              :key="index"
              class="product-item"
              @click="goOrder(item)"
            >
              <div class="product-item-title">
                <span>{{ item.saleName }}</span>
                <!-- <span
                  v-if="item.isRecommend"
                  class="is-recommend"
                >推荐</span> -->
              </div>
              <div class="product-item-content">
                {{ item.productMemo }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 认证弹框 -->
    <Modal
      v-model="authModal.visiable"
      :footer-hide="true"
      :closable="false"
      :width="500"
    >
      <div class="authModal-img">
        <img src="@/assets/images/auth.png">
      </div>
      <div class="authModal-content">
        <div class="authModal-info-item">
          1.如果您的账号已加入某个商家，请联系商家邀请您加入；
        </div>
        <div class="authModal-info-item">
          2.如果您要做商家主体认证 <span
            class="go-auth"
            @click="goMyCorp"
          >请前往认证</span>
        </div>
      </div>
      <div class="footer-box">
        <button
          class="auth-btn"
          @click="authModal.on.close"
        >
          我知道了
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  components: {},
  filters: {
    passFormat(value) {
      if (value) {
        let pass = '';
        const { length } = value;
        let len = 1;
        if (length > 6) {
          len = 3;
          pass = `${value.substr(0, len) }***${ value.substr(length - len, len)}`;
        } else if (length > 4) {
          len = 2;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 2) {
          len = 1;
          pass = value.substr(0, len) + '*'.repeat(length - 2 * len) + value.substr(length - len, len);
        } else if (length > 1) {
          len = 1;
          pass = `${value.substr(0, len) }*`;
        } else {
          pass = value;
        }
        return pass;
      } else {
        return value;
      }
    },
    filterCorpName(value){
      // 公司名称最长六个字，超过截取
      let corpName = value;
      if (value && value.length>6){
        corpName = value.substr(0,6);
      }
      return corpName;
    },
  },
  data() {
    return {
      authModal: {
        visiable: false,
        on: {
          show: ()=>{
            this.authModal.visiable = true;
          },
          close: ()=>{
            this.authModal.visiable = false;
          },
        },
      },
      // subMenuList: [],
      menuList: [
        // {
        //   privilegeMark: 'index',
        //   privilegeName: '工作台',
        //   privilegeUrl: '/',
        // },
        {
          privilegeMark: 'app',
          privilegeName: '应用市场',
          privilegeUrl: '/app/market/index',
        },
        {
          privilegeMark: 'developerCenter',
          privilegeName: '开放平台',
          privilegeUrl: this.common.config.openDomain,
        },
        // {
        //   privilegeMark: 'standardProduct',
        //   privilegeName: '订购服务',
        //   privilegeUrl: '/standardProduct/productVersion/index',
        // },
        // {
        //   privilegeMark: 'orderRecord',
        //   privilegeName: '订购记录',
        //   privilegeUrl: '/app/orderRecord/index',
        // },
      ],
      product: {
        show: false,
        list: [],
      },

      corpList: {
        selectIndex: 0,
        on: {
          click: (index)=>{
            this.corpList.selectIndex = index;
            const item = this.userInfo.corpList[index]||{};

            // 设置主题
            this.$store.commit('setUserInfo',{
              corpCode: item.key,corpName: item.value,
            });
            // this.userInfo = {...this.$store.state.user.userInfo};

            // 触发主体change事件
            this.$root.$emit('on-corp-change',item.key);
            // this.$emit('on-corp-change',item.key);
          },
        },
      },
      dropdownMenu: {
        list: [
          {
            title: '我的应用',
            on: {
              click: ()=>{
                this.$router.push({
                  path: '/app/myApp/index',
                  // query: {
                  //   appType: 'myApp',
                  // },
                });
              },
            },
          },
          {
            title: '订购记录',
            on: {
              click: ()=>{
                this.$router.push({
                  path: '/app/orderRecord/index',
                  query: {

                  },
                });
              },
            },
          },
          {
            title: '退出登录',
            on: {
              click: ()=>{
                this.loginOut();
              },
            },
          },
        ],
      },
      headerStyle: {},
    };
  },
  computed: {
    userInfo(){
      return this.$store.state.user.userInfo;
    },
    subMenuList() {
      // // 过滤掉按钮
      // const getSubMenuList = (subMenuList, menuList = { items: [] }) => {
      //   const menu = subMenuList.items;
      //   if (menu && menu.length) {
      //     menu.forEach(ele => {
      //       let menuItem = {};
      //       if (Number(ele.privilegeMenuType) !== 2) {
      //         // 过滤掉按钮
      //         menuItem = { ...ele };
      //         menuItem.items = [];
      //         menuList.items.push(menuItem);
      //       }
      //       if (ele.items && ele.items.length) {
      //         getSubMenuList(ele, menuItem);
      //       }
      //     });
      //   }
      //   return menuList;
      // };

      // const subMenuList = getSubMenuList();
      return this.$store.state.menu.subMenuList;
    },
    // userInfo(){
    //   return this.$store.state.user.userInfo;
    // },
    // phone() {
    //   const {accountNo} = this.$store.state.user.userInfo;
    //   return accountNo;
    // },
  },
  watch: {
    $route: {
      handler: function(){
        if (this.$route.name === 'productVersion'){
          this.headerStyle.boxShadow = 'none';
        } else {
          this.headerStyle.boxShadow = '0 0 15px 1px #ddd';
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$root.$on('header-style',(headerStyle)=>{
      this.headerStyle = headerStyle;
    });
  },
  mounted(){
    // 刷新的时候corpList会被清除
    // 刷新页面的时候重新获取用户信息
    // const {corpList} = this.$store.state.user;
    // if (!corpList){
    //   this.$store.dispatch('getUserInfo');
    // }

    this.$root.$on('show-auth-modal',()=>{
      this.authModal.on.show();
    });
    this.getProduct();
  },
  beforeDestroy(){
    this.$root.$off('layout-style');
    this.$root.$off('show-auth-modal');
  },
  methods: {

    // 获取用户信息
    // getUserInfo(){
    //   const url = '/paycenter-charge/api/worktable/user/info';
    //   this.$http.get(url).then(res=>{
    //     if (res.success){
    //       this.userInfo = res.data;
    //       // 默认主体选择第一个
    //       const item = this.userInfo.corpList[0]||{};
    //       this.$store.commit('setUserInfo',{
    //         corpCode: item.key,corpName: item.value,
    //       });
    //       // 触发主体change事件
    //       this.$root.$emit('on-corp-change',item.key);
    //     } else {
    //       this.$Message.warning(res.message||'获取用户信息失败');
    //     }
    //   });
    // },
    loginOut() {
      // 清除缓存
      this.$store.commit('clearUserInfo');
      this.userInfo = {};
      this.$router.push({
        path: '/app/market/list',
      });
      // this.$store.commit('clearUserInfo');
      // this.goLogin();
      // window.location.href = '/login'; // 使用这种方式跳转到登录页面，是为了清空state,route 防止动态路由重复添加
      // this.$router.push('/login').catch();
    },
    changeTab(item) {
      const activeName = item.privilegeMark;
      if (activeName==='developerCenter'){
        window.location.href = item.privilegeUrl;

      }
      // else if (activeName==='app'){
      //   this.$Message.warning('应用市场开发中');
      // }
      const menuItem = this.menuList.find(ele=>ele.privilegeMark===activeName);
      if (menuItem.privilegeUrl!==this.$route.fullPath){
        this.$router.push(menuItem.privilegeUrl).catch();
      }

    },
    goHome() {
      this.$router.push('/');
    },
    // 登录
    goLogin(){
      // 清除缓存
      this.$store.commit('clearUserInfo');
      // 去用户中心登录
      // 登陆完成之后会在重定向回来，并在路径后面拼接token
      // 去除redirectUrl中的 redirectUrl
      // const redirectUrl = this.common.utils.delParam({
      //   key: 'redirectUrl',
      //   url: window.location.href,
      // });
      let redirectUrl = window.location.href;
      if (window.location.pathname==='/app/market/list'){
        redirectUrl = window.location.origin;
      }
      window.location.href = `${this.common.config.userDomian}/usercenter/login?redirectUrl=${encodeURIComponent(redirectUrl)}`;

    },
    // 注册
    register(){
      // 清除缓存
      this.$store.commit('clearUserInfo');
      // const redirectUrl = this.common.utils.delParam({
      //   key: 'redirectUrl',
      //   url: window.location.href,
      // });
      window.location.href = `${this.common.config.userDomian}/usercenter/step/register?redirectUrl=${encodeURIComponent(window.location.href)}`;
    },
    // 新增企业
    goMyCorp(){
      const {token} = this.$store.state.user.userInfo;
      // window.open(`${this.common.config.userDomian}/usercenter/user/subjectMg?token=${token}`,'_blank');
      window.location.href = `${this.common.config.userDomian}/usercenter/user/subjectMg?token=${token}`;
    },
    showProduct(){
      this.product.show = true;
    },
    hideProduct(){
      this.product.show = false;
    },
    getProduct(){
      this.$store.dispatch('getProductShortList').then((data)=>{
        this.product.list = data;
      });
    },
    goOrder(item){
      this.$router.push({
        path: '/standardProduct/productVersion/index',
        query: {
          productCode: item.productCode,
        },
      });
      this.product.show = false;
    },
  },
};
</script>

<style scoped lang="less">
@defaultColor: #4772fc;
.wrap1200 {
  width: 1200px;
  margin: 0 auto;
}
.auth-box {
  text-align: center;
  background-color: #ffe5df;
  color: #333;
  padding: 10px;
  position: relative;
  z-index: 99;
  .auth-tip {
    display: inline-block;
    vertical-align: middle;
    margin-right: 40px;
  }
  .vertify-btn {
    background: @defaultColor;
    color: #fff;
    border: 0;
    padding: 2px 10px;
    font-size: 14px;
    cursor: pointer;
  }
}
.header-box {
  box-shadow: 0 0 15px 1px #ddd;
  background-color: #fff;
  position: relative;
  z-index: 9;
  border-bottom: 1px solid #efefef;
}
.header {
  width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 9;
  background-color: #fff;
  .wrap1200 {
    display: flex;
    align-items: center;
  }
  &::after {
    content: '';
    display: block;
    clear: both;
  }
}
.header-col {
  display: inline-block;
  vertical-align: middle;
}
.header-left {
  // width: 220px;
}
.header-right {
  margin-left: auto;
  .user-icon {
    width: 36px;
    height: 36px;
    border-radius: 100%;
    vertical-align: middle;
    margin-right: 10px;
  }
  .is-login {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.header-menu1 {
  margin: 0 50px;
}
/deep/.ivu-select-dropdown{
  width: auto;
}
.menu {
  float: right;
  padding-right: 30px;
  .menu-list {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  .menu-item {
    margin-right: 60px;
    cursor: pointer;
    padding: 22px 0;
    .product-show {
      transform: rotate(180deg);
    }
  }
}
.product {
  position: absolute;
  z-index: 1;
  transform: translateY(calc(-100% - 135px));
  width: 100%;
  left: 0;
  background-color: #fff;
  transition: all 0.5s;
  box-sizing: border-box;
  box-shadow: 0 0 15px 1px #ddd;
  padding-bottom: 15px;
  .wrap1200 {
    padding: 0 40px;
  }
  &-title {
    margin: 30px 0 32px;
    padding-left: 12px;
    position: relative;
    height: 22px;
    line-height: 22px;
    &::before {
      content: '';
      width: 3px;
      height: 12px;
      position: absolute;
      left: 0;
      top: 5px;
      background-color: #4772fc;
    }
  }
  &.show {
    transform: translateY(1px);
  }
  &-list {
    display: grid;
    grid-template-columns: repeat(3, 33%);
  }
  &-item {
    list-style: none;
    margin-bottom: 20px;
    cursor: pointer;
    width: 70%;
    padding: 5px 10px;
    transition: all 0.3s;
    &:hover {
      background-color: #efefef;
    }
    &-title {
      font-size: 18px;
      color: #333;
      margin-bottom: 4px;
      span {
        vertical-align: middle;
      }
      .is-recommend {
        font-size: 10px;
        color: #f03337;
        padding: 2px 3px;
        border: 1px solid #f03337;
        border-radius: 2px;
        margin-left: 12px;
      }
    }
    &-content {
      font-size: 12px;
      color: #999;
      line-height: 16px;
      height: 32px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
.logo-img {
  height: 36px;
  vertical-align: middle;
  margin-right: 5px;
  cursor: pointer;
}
.corpList-box {
  display: inline-block;
  padding: 0 10px;
  margin-right: 50px;
  /deep/ .ivu-dropdown-item {
    padding: 0;
  }
  /deep/ .ivu-select-dropdown {
    padding: 0;
    overflow: hidden;
  }
  .corpList-select {
    // padding: 0;
  }
  .corpList-item {
    box-sizing: border-box;
    padding: 3px 10px;
    margin-bottom: 5px;
    width: 100%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
    // line-height: 26px;
  }
  .corpList-item-select {
    cursor: pointer;
    box-sizing: border-box;
    padding: 0 10px;
    // width: 150px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
    .corpList-select-text {
      display: inline-block;
      vertical-align: middle;
    }
  }
  .corpList-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #5a81ff;
    padding: 5px 0;
    .line {
      display: inline-block;
      width: 1px;
      height: 20px;
      background-color: #e5e5e5;
    }
    .footer-item {
      width: 50%;
      text-align: center;
    }
  }
}
.add-corp {
  color: @defaultColor;
}
.plat-name {
  margin-left: 5px;
}
.userinfo {
  padding-top: 2px;
  .btn {
    box-sizing: border-box;
    cursor: pointer;
    padding: 3px 15px;
    // color: #fff;
    border: 0;
    margin-right: 20px;
    background-color: transparent;
    &1 {
      color: #fff;
      background-color: @defaultColor;
    }
    &2 {
      color: @defaultColor;
      // background-color: @defaultColor;
      border: 1px solid @defaultColor;
    }
  }
}
.dropdown-box {
  /deep/ .ivu-dropdown-item:hover {
    background: #f3f6ff;
  }
  .footer {
    box-shadow: 0 0 10px 1px #eee;
    &:hover {
      background: unset;
    }
  }
}
.menu-tip {
  font-size: 12px;
  color: #999;
  // position: absolute;
}
.authModal-img {
  text-align: center;
  padding: 20px 0;
}
.authModal-content {
  margin-left: 60px;
  color: #999;
  .authModal-info-item {
    margin-bottom: 8px;
  }
}
.footer-box {
  text-align: center;
  margin: 35px 0 40px;
}
.auth-btn {
  background: #fff;
  border: 1px solid @defaultColor;
  border-radius: 2px;
  color: @defaultColor;
  padding: 2px 10px;
  cursor: pointer;
}
.go-auth {
  display: inline-block;
  color: @defaultColor;
  margin-left: 10px;
  cursor: pointer;
}

</style>
